import type { Survey2AssortSaver } from "../../../../models/Survey";

/**
 * Odpowiedź GET `/admin/survey` — elementy mogą być `{ assortIds, sections }` albo linią koszyka z `{ survey }`.
 */
export const normalizeSurveyMapFromApi = (result: unknown): Record<string, Survey2AssortSaver> => {
  const map: Record<string, Survey2AssortSaver> = {};
  if (!Array.isArray(result)) return map;

  (result as unknown[]).forEach((raw) => {
    const entry = raw as Record<string, unknown>;
    const assortIds = entry?.assortIds as string | undefined;
    if (!assortIds) return;
    if (Array.isArray(entry.sections)) {
      map[assortIds] = entry as unknown as Survey2AssortSaver;
      return;
    }
    const survey = entry?.survey as Survey2AssortSaver | undefined;
    if (survey?.sections) {
      map[assortIds] = survey;
    }
  });

  return map;
};
